/**
 * Fix BR (2026-11-03): montos en formato argentino SIEMPRE con punto de miles y coma decimal.
 * toLocaleString("es-AR") no agrupa los números de 4 cifras (muestra "1234") y depende del navegador.
 */
const group = (intDigits) => intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

export function formatARS(n, decimals = 2) {
  const v = Number(n || 0);
  const [int, dec] = Math.abs(v).toFixed(decimals).split(".");
  return `${v < 0 ? "-" : ""}$ ${group(int)}${decimals ? `,${dec}` : ""}`;
}

// "1.500.000,5" -> 1500000.5
export function parseAR(text) {
  const v = Number(String(text || "").replace(/\./g, "").replace(",", "."));
  return Number.isFinite(v) ? v : 0;
}

// 1500000.5 -> "1.500.000,5" (para mostrar en un campo editable; "" si es 0)
export function groupAR(value) {
  const v = Math.round((Number(value) || 0) * 100) / 100;
  if (!v) return "";
  const [int, dec] = String(Math.abs(v)).split(".");
  return `${v < 0 ? "-" : ""}${group(int)}${dec ? `,${dec}` : ""}`;
}
